/**
 * Return status constants
 * These represent the various states a return can be in during its lifecycle
 */
export const RETURN_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS', // Return has been submitted
  READY_TO_SHIP: 'READY_TO_SHIP', // Return is ready to be shipped back
  IN_TRANSIT: 'IN_TRANSIT', // Return is being shipped back to retailer
  HANDED_OFF: 'HANDED_OFF', // Return has been handed off (terminal state)
  COMPLETE: 'COMPLETE', // Return is complete (terminal state)
}

/**
 * Refund status constants
 * These represent the various states of a refund for a return
 */
export const REFUND_STATUS = {
  ELIGIBLE: 'ELIGIBLE', // Customer is eligible for a refund
  NOT_ELIGIBLE: 'NOT_ELIGIBLE', // Customer is not eligible for a refund
  ACCEPTED: 'ACCEPTED', // Customer has accepted the refund
}

/**
 * Credit type constants
 * These represent what kind of credit the customer receives for a return
 */
export const CREDIT_TYPE = {
  IN_STORE_CREDIT: 'IN_STORE_CREDIT', // Customer receives store credit
  REFUND: 'REFUND', // Customer receives a refund to original payment method
}

/**
 * Financial status constants
 * These represent the financial processing state of a return
 */
export const FINANCIAL_STATUS = {
  IN_STORE_CREDIT_CREATED: 'IN_STORE_CREDIT_CREATED', // Store credit has been issued
  REFUNDED: 'REFUNDED', // Refund has been processed
  REFUNDED_BY_RETAILER: 'REFUNDED_BY_RETAILER', // Retailer issued refund directly in Shopify
}
